export enum InteractionType {
    contactPhone = 0,
    contactEmail = 1,
    contactWhatsapp = 2,
    locationMap = 3,
    visitsFacebook = 4,
    visitsInstagram = 5,
    visitsTwitter = 6,
    visitsYoutube = 7,
    visitsPinterest = 8,
    visitsLinkedin = 9,
    visitsMyWebsite = 10,
    visitsTikTok = 11,
    visitsTelegram = 12,
    shared = 13,
    savedContact = 14,
    readsQRCode = 15,
    userContentLink = 16,
    visitsMyOnlineShop = 17
}
export class BusinessTotalInteractionsKpi {
    public interaction?: InteractionType;
    public count: number | null = null;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
